/**
 * Shared base classes for DialogContent and AlertDialogContent.
 *
 * DEVIATES FROM UPSTREAM SHADCN ON PURPOSE — do not "fix" this back to
 * `w-full max-w-[calc(100%-2rem)] ... sm:max-w-lg`, and note that re-running
 * `npx shadcn add dialog|alert-dialog --overwrite` silently reverts it.
 *
 * Upstream caps width with a breakpoint-prefixed `sm:max-w-lg`. tailwind-merge
 * only dedupes classes sharing the same variant modifier, so a caller writing
 * `<DialogContent className="max-w-2xl">` gets BOTH classes, and the `sm:`
 * media query is emitted after base utilities — the dialog stays clamped to
 * 512px at every viewport >= 640px. Worse, twMerge *does* dedupe the unprefixed
 * `max-w-[calc(100%-2rem)]` against that override, stripping the mobile gutter
 * and rendering the dialog edge-to-edge at 100vw on phones.
 *
 * The fix is the pairing below:
 *   - `w-[calc(100%-2rem)]` owns the mobile gutter. It lives in the `w` group,
 *     where a `max-w-*` override cannot evict it. Percentages resolve against
 *     the viewport (the element is `fixed`, portalled to `body`).
 *   - `max-w-lg` is a single UNPREFIXED cap, so callers can override it.
 *
 * `grid-cols-[minmax(0,1fr)]` gives the single column a min track sizing
 * function of 0, disabling the automatic minimum size of grid items
 * (CSS Grid Layout, §6.6). Without it, `whitespace-nowrap` table content
 * expands the track past the container and paints outside the dialog.
 *
 * Covered by dialog-content-class.test.ts.
 */
export const DIALOG_CONTENT_BASE =
  "bg-background data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 fixed top-[50%] left-[50%] z-50 grid w-[calc(100%-2rem)] max-w-lg grid-cols-[minmax(0,1fr)] translate-x-[-50%] translate-y-[-50%] gap-4 rounded-lg border p-6 shadow-lg duration-200"
